export const STARTAPI_REQUEST_UNSEAL_TEC = 'STARTAPI_REQUEST_UNSEAL_TEC'
export const SENDAPI_REQUEST_UNSEAL_TEC = 'SENDAPI_REQUEST_UNSEAL_TEC'
